export default {
  name: 'App',
  mounted() {},
  created() {}
};